module.exports = __webpack_public_path__ + "img/e5e5e5_grey.afc7221c.png";